import React from "react";
import { useSelector } from "react-redux";
import { loggerModel } from "../../../entities/Logger";
import "./InfoBar.scss";
const InfoBar = () => {
  const loggerState = useSelector(loggerModel.selectLoggerState);
  const { deviceDisplayState, deviceSpeechState, deviceState, serverState } =
    loggerModel.selectLoggerInfo(loggerState);

  return (
    <div className="info_bar">
      <div className="info_bar__item">
        <div className="info_bar__item__title">Состояние (Сервер)</div>
        <div className="info_bar__item__value">{serverState}</div>
      </div>
      <div className="info_bar__item">
        <div className="info_bar__item__title">Состояние (Котич)</div>
        <div className="info_bar__item__value">{deviceState}</div>
      </div>
      <div className="info_bar__item">
        <div className="info_bar__item__title">Дисплей</div>
        <div className="info_bar__item__value">{deviceDisplayState}</div>
      </div>
      <div className="info_bar__item">
        <div className="info_bar__item__title">Спич</div>
        <div className="info_bar__item__value">{deviceSpeechState}</div>
      </div>
    </div>
  );
};

export default InfoBar;
